// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9h-0";
export var optionCard = "_9h-1";